import request from '@/utils/request'

// 获取团队路线
export function GetTeamRouteList (params) {
  return request({
    url: 'post/route/GetTeamRouteList',
    data: params
  })
}

// 获取团队路线
export function GetTeamRoutesByIds (params) {
  return request({
    url: 'post/route/GetTeamRoutesByIds',
    data: params
  })
}

// 路线规划
export function RoutePlanning (params) {
  return request({
    url: 'post/route/RoutePlanning',
    data: params
  })
}

export function SetRouteUser (params) {
  return request({
    url: 'post/route/SetRouteUser',
    data: params
  })
}
export function BatchExportRoute (params) {
  return request({
    url: 'post/route/BatchExportRoute',
    data: params
  })
}

export function SaveRouteRemarks (params) {
  return request({
    url: 'post/route/SaveRouteRemarks',
    data: params
  })
}

export function GetRouteDetails (params) {
  return request({
    url: 'post/route/GetRouteDetails',
    data: params
  })
}


export function GetRoutePlace (params) {
  return request({
    url: 'post/route/GetRoutePlace',
    data: params
  })
}

export function SaveRoute (data) {
  return request({
    url: 'post/route/SaveRoute',
    data
  })
}
export function GetHDGTeamTodayRoutes () {
  return request({
    url: 'post/route/GetHDGTeamTodayRoutes',
  })
}

export function GetRoutePlaces (params) {
  return request({
    url: 'post/route/GetRoutePlaces',
    data: params
  })
}
export function GetHDGRoutePlaces (params) {
  return request({
    url: 'post/route/GetHDGRoutePlaces',
    data: params
  })
}


export function GetRoutePlacePhotos (data) {
  return request({
    url: 'post/route/GetRoutePlacePhotos',
    data
  })
}


export function GetRouteMapDetails (params) {
  return request({
    url: 'post/route/GetRouteMapDetails',
    data: params
  })
}

export function DeleteRoute (params) {
  return request({
    url: 'post/route/DeleteRoute',
    data: params
  })
}
export function UpdateHDGRoute (data) {
  return request({
    url: 'post/route/UpdateHDGRoute',
    data
  })
}

export function BatchDeleteRoute (params) {
  return request({
    url: 'post/route/BatchDeleteRoute',
    data: params
  })
}

export function ExportRoute (params) {
  return request({
    url: 'post/route/ExportRoute',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/route.js